import { useEffect, useState } from "react"
import { Box, Loader } from "@nef/core"
import { useDispatch, useSelector } from "react-redux"

import { AppDispatch, RootState } from "../../../../app/store"
import { getInstrumentTypeCategory } from "../../../../redux/property/actions"

const InstrumentList = () => {
  const instrumentTypes: any = useSelector((state: RootState) => state.property.instrumentTypeCategory)
  const dispatch = useDispatch<AppDispatch>()
  const [transformedInstrumentTypes, setTransformedInstrumentTypes] = useState<any>({})

  // tranform the instrument types response for UI rendering
  const transformInstrumentTypes = () => {
    const transformedData: any = {}
    instrumentTypes.forEach((instrument: any) => {
      const { typeDescription: type, categoryDescription: category } = instrument
      if (type in transformedData) {
        // add the category only if it isn't present already
        if (transformedData[type].includes(category)) return
        transformedData[type].push(category)
      } else {
        // when the key not present, add the key to the tranformed object with the category value in the array
        transformedData[type] = [category]
      }
    })
    setTransformedInstrumentTypes(transformedData)
  }

  useEffect(() => {
    if (!instrumentTypes?.length) dispatch(getInstrumentTypeCategory()).unwrap()
    else transformInstrumentTypes()
  }, [instrumentTypes])

  return (
    <>
      {Object.keys(transformedInstrumentTypes).length ? (
        <Box className="asset-classes">
          <ul className="asset-class-list">
            {Object.keys(transformedInstrumentTypes).map((key: string) => (
              <li key={key}>
                {key}
                <ul>
                  {transformedInstrumentTypes[key].map((category: string) => (
                    <li key={category}>{category}</li>
                  ))}
                </ul>
              </li>
            ))}
          </ul>
        </Box>
      ) : (
        <div className="property-manager__container progress">
          <Loader isLoading />
        </div>
      )}
    </>
  )
}

export default InstrumentList
